module.exports = __webpack_public_path__ + "img/check-s.3bc69ed1.svg";